var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5886 4.41083C15.914 4.73626 15.914 5.2639 15.5886 5.58934L5.5886 15.5893C5.26317 15.9148 4.73553 15.9148 4.41009 15.5893C4.08466 15.2639 4.08466 14.7363 4.41009 14.4108L14.4101 4.41083C14.7355 4.08539 15.2632 4.08539 15.5886 4.41083Z",
    fill: "#FFA30C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41009 4.41083C4.73553 4.08539 5.26317 4.08539 5.5886 4.41083L15.5886 14.4108C15.914 14.7363 15.914 15.2639 15.5886 15.5893C15.2632 15.9148 14.7355 15.9148 14.4101 15.5893L4.41009 5.58934C4.08466 5.2639 4.08466 4.73626 4.41009 4.41083Z",
    fill: "#FFA30C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.594cf6849bb0608f3e805b1929d680fc.svg";
export { ForwardRef as ReactComponent };